module.exports = __webpack_public_path__ + "static/media/14.5eaffd42.jpg";